import React, {CSSProperties, forwardRef} from "react";
import {lockIcon} from "../../assets/icons";
import {TButtonProps} from "./types";
import styles from './Button.module.scss'
import {classNames} from "@shared/utils";

export const Button = forwardRef((props: TButtonProps, forwardRef) => {

    const {fullHeight = false, fullWidth = false, variant, color, className, ...buttonProps} = props;

    const classNameButton = classNames(
        styles.root,
        {
            [styles.root_fullWidth]: fullWidth,
            [styles.root_fullHeight]: fullHeight,
            [styles.root_variant_text]: variant === "text",
            [styles[`root_color_${color}`]]: !!color
        },
        className
    )

    return (
        <button
            className={classNameButton}
            {...buttonProps}
            ref={forwardRef}
        >
            {props.children}
        </button>
    )
})
